// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Accordion/TitlesSubtitles.story.tsx with go/sail-next-tailor-docs-publisher 

import React from 'react';
import { Accordion, AccordionItem, view } from '@sail/ui';
import { PanelExample } from './PanelExample';
export const TitlesSubtitles = () => {
  return <view.div css={{
    background: 'surface'
  }}>
      <Accordion>
        <AccordionItem title="Apples" key={1}>
          <PanelExample />
        </AccordionItem>
        <AccordionItem title="Bananas" key={2}>
          <PanelExample />
        </AccordionItem>
        <AccordionItem title="Oranges" key={3}>
          <PanelExample />
        </AccordionItem>
        <AccordionItem title="Peaches" subtitle="A subtitle can be provided" key={4}>
          <PanelExample />
        </AccordionItem>
      </Accordion>
    </view.div>;
};